export default "__VITE_ASSET__CWWhf8Ke__"